module.exports = __webpack_public_path__ + "static/media/Group 21.ccae114b.svg";